<li *ngIf="showShortcuts" ngbDropdown class="nav-item dropdown dropdown-shortcuts d-none d-lg-block mr-25">
  <a
    class="nav-link dropdown-toggle hide-arrow d-flex align-items-center"
    id="dropdown-shortcuts"
    ngbDropdownToggle
    role="button"
    aria-haspopup="true"
    aria-expanded="false"
    title="Phím tắt nhanh"
  >
    <lucide-angular name="layout-grid" size="21"></lucide-angular>
  </a>

  <div
    ngbDropdownMenu
    aria-labelledby="dropdown-shortcuts"
    class="dropdown-menu dropdown-menu-right dropdown-menu-shortcuts p-0 shadow-lg border-0"
  >
    <!-- Dropdown Header -->
    <div class="dropdown-menu-header border-bottom p-1 d-flex align-items-center justify-content-between">
      <h6 class="dropdown-header-title font-weight-bolder text-dark mb-0">
        {{ isManageOpen ? 'Tùy chỉnh Phím tắt' : 'Phím tắt nhanh' }}
      </h6>
      <div class="d-flex align-items-center">
        <button
          *ngIf="isManageOpen"
          class="btn btn-sm btn-outline-primary py-25 px-50 font-small-1 font-weight-bold mr-75"
          (click)="resetDefaults()"
          title="Đặt lại mặc định"
        >
          Mặc định
        </button>
        <button
          class="btn btn-sm btn-icon btn-flat-secondary p-0"
          [title]="isManageOpen ? 'Đóng tùy chỉnh' : 'Thêm phím tắt'"
          (click)="onAddShortcut()"
        >
          <lucide-angular [name]="isManageOpen ? 'x' : 'plus'" size="18"></lucide-angular>
        </button>
      </div>
    </div>

    <!-- 1. Grid View phím tắt đã chọn -->
    <div *ngIf="!isManageOpen" class="dropdown-shortcuts-list">
      <div class="row no-gutters">
        <a
          *ngFor="let item of shortcuts"
          [routerLink]="item.link"
          class="dropdown-shortcuts-item col-6 text-center py-1 px-75 border-bottom border-right"
        >
          <div
            class="avatar p-50 mb-50 mx-auto d-inline-flex align-items-center justify-content-center"
            [ngClass]="'bg-light-' + (item.color || 'primary')"
            style="width: 44px; height: 44px; border-radius: 50%;"
          >
            <lucide-angular [name]="item.icon" size="20"></lucide-angular>
          </div>
          <span class="d-block font-weight-bolder text-dark font-small-2 mb-25">{{ item.title }}</span>
          <small class="d-block text-secondary font-small-1">{{ item.subtitle }}</small>
        </a>

        <div *ngIf="shortcuts.length === 0" class="col-12 text-center p-2 text-secondary font-small-2">
          Chưa có phím tắt nào. Bấm nút (+) để thêm.
        </div>
      </div>
    </div>

    <!-- 2. Quản lý danh sách phím tắt (Tùy chỉnh) -->
    <div *ngIf="isManageOpen" class="dropdown-shortcuts-manage p-75" style="max-height: 320px; overflow-y: auto;">
      <div
        *ngFor="let route of allAvailableRoutes"
        class="shortcut-manage-item d-flex align-items-center justify-content-between p-50 rounded mb-25"
        [class.bg-light-primary]="isShortcutActive(route.id)"
        (click)="toggleShortcut(route)"
        style="cursor: pointer; transition: background 0.15s ease;"
      >
        <div class="d-flex align-items-center">
          <div
            class="avatar p-25 mr-75 d-flex align-items-center justify-content-center"
            [ngClass]="isShortcutActive(route.id) ? ('bg-light-' + (route.color || 'primary')) : 'bg-light-secondary'"
            style="width: 32px; height: 32px; border-radius: 50%;"
          >
            <lucide-angular [name]="route.icon" size="16"></lucide-angular>
          </div>
          <div>
            <strong class="font-small-2 text-dark d-block">{{ route.title }}</strong>
            <small class="font-small-1 text-secondary">{{ route.subtitle }}</small>
          </div>
        </div>
        <span
          class="badge badge-pill font-small-1"
          [class.badge-primary]="isShortcutActive(route.id)"
          [class.badge-light-secondary]="!isShortcutActive(route.id)"
        >
          {{ isShortcutActive(route.id) ? 'Đã thêm' : 'Thêm' }}
        </span>
      </div>
    </div>
  </div>
</li>
